import { render } from "./TextDisplay.vue?vue&type=template&id=0ae3121e&scoped=true"
import script from "./TextDisplay.vue?vue&type=script&lang=js"
export * from "./TextDisplay.vue?vue&type=script&lang=js"

import "./TextDisplay.vue?vue&type=style&index=0&id=0ae3121e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae3121e"]])

export default __exports__